import React from 'react';
import PageHero from '../components/PageHero';

import ContactSection from '../components/ContactSection';
import LocationMap from '../components/LocationMap';
import Partners from '../components/Partners';

const ContactUs = () => {
    return (
        <>
            <PageHero
                title="Get In Touch"
                showButton={false}
                description="We’d love to hear from you! Whether you’re curious about our nursery, want to arrange a visit, or have questions about our curriculum, our team is here to help."
            />
            <ContactSection />
            <LocationMap />
            <Partners />
        </>
    );
};

export default ContactUs;
